import * as React from "react";
import { useContext, useState } from "react";
import styled from "styled-components";
import { Popover } from "antd"; // TODO: remove antd dependency

import { Button, DropdownContext, IconTypes } from "../index";
import { ButtonKinds } from "../Button/types";
import { useDropdownBtn } from "./hooks";
import { themeValues } from "../theme";

export const StyledDropdownItem = styled.div`
  border: none;
  background-color: transparent;
  font-size: ${themeValues.fontSize.normal};

  padding: 8px 16px;
  cursor: pointer;
  min-width: 150px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  width: 100%;

  & p {
    font-weight: 400;
  }

  &.separator {
    cursor: initial;
  }

  &.with-indicator {
    padding: 8px 16px 8px 40px;
  }

  &:hover {
    background-color: #f5f5f5;
    color: #000;

    &.hover-bold {
      font-weight: 700;
    }

    &.separator {
      background-color: transparent;
    }
  }

  &.controls {
    min-width: 107px;
    font-weight: 400;
    text-align: center;
    color: #000 !important;

    font-size: ${themeValues.fontSize.normal};
    padding: 8px 0;
    margin: 0 auto;
    display: block;
    align-items: center;
  }

  .ant-switch-small.ant-switch-checked .ant-switch-handle {
    left: 50%;
  }

  &.button-with-feature {
    padding: 0;

    & .with-feature {
      display: flex;
      padding: 8px 16px;
      width: 100%;
    }
  }
`;
StyledDropdownItem.displayName = "StyledDropdownItem";

const StyledDropdownContent = styled.div`
  padding: 8px 0 8px 0;
  max-height: 50vh;
  overflow: auto;
  overflow-x: hidden;
`;
StyledDropdownContent.displayName = "StyledDropdownContent";

interface IDropdownProps {
  children: React.ReactElement[];
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function Dropdown({ open: openProp, children = [] }: IDropdownProps): JSX.Element {
  const [open, setOpen] = useState(openProp || false);

  const childHead = children[0];
  const [, ...childTail] = children.length > 1 ? children : [null, null];

  function close() {
    setOpen(false);
  }

  const content = <StyledDropdownContent>
    {childTail}
  </StyledDropdownContent>;

  return <DropdownContext.Provider value={{
    open,
    setOpen
  }}>
    <Popover
      placement="bottomLeft"
      content={content}
      trigger="click"
      onVisibleChange={close}
      visible={open}
      overlayClassName="dropdown-hide-arrow" // TODO: it works only for ls use case
    >
      {childHead}
    </Popover>
  </DropdownContext.Provider>;
}

const StyledDropdownButton = styled.span`

`;
StyledDropdownButton.displayName = "StyledDropdownButton";


// TODO: finish DropdownButton
export function DropdownButton(): JSX.Element {
  return <></>;
}

// TODO: DropdownAnchor - should enable for custom button injection
export function DropdownAnchor(): JSX.Element {
  return <></>;
}

interface IDropdownIconTogglerProps {
  color?: ButtonKinds;
  icon?: IconTypes;
}

export function DropdownIconToggler({
                                      color = "primary",
                                      icon = "icon-more-options"
                                    }: IDropdownIconTogglerProps): JSX.Element {
  const { toggle } = useDropdownBtn();

  return <StyledDropdownButton>
    <Button
      theme="outline"
      kind={color}
      icon={icon}
      onClick={toggle}
    />
  </StyledDropdownButton>;
}

interface IDropdownItemProps {
  children: React.ReactElement | string;
  onClick?: () => void;
}

export function DropdownItem({ children, onClick: onClickProp }: IDropdownItemProps): JSX.Element {
  const { setOpen } = useContext(DropdownContext)

  function onClick() {
    setOpen(false)
    if (!onClickProp) {
      return
    }

    onClickProp()
  }

  return <StyledDropdownItem onClick={onClick}>
    {children}
  </StyledDropdownItem>;
}
